import script from "./ToolboxHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolboxHome.vue?vue&type=script&setup=true&lang=js"

import "./ToolboxHome.vue?vue&type=style&index=0&id=2652ed01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2652ed01"]])

export default __exports__